import { Button, Stack } from '@atgfr8/atg-ui-tailwind';
import { OpenInNewIcon } from '@atgfr8/icons';
import { carrier } from '@store/orders/selectors';
import { createMemo, Show } from 'solid-js';

export const HighwayItemsRow = () => {
  const c = () => carrier();
  const insightCount = () => c()?.carrierInsightViewModels?.length ?? 0;
  const hasAlerts = () =>
    Boolean(c()?.hasWatchDogAlerts) || Boolean(c()?.hasIdentityAlerts);
  const failingCount = () => c()?.failingHighwayRuleCodingsCount ?? 0;

  const intelSummary = createMemo(() => {
    const parts: string[] = [];
    if (insightCount() > 0) parts.push(`${insightCount()} Highway Insights`);
    if (hasAlerts()) parts.push('Carrier Alerts');
    if (failingCount() > 0) {
      parts.push(`${failingCount()} Assessment Failures`);
    }
    return parts.join(' • ');
  });

  return (
    <Stack direction="row" class="w-full items-start justify-between gap-x-2">
      <Stack direction="column" class="min-w-0">
        <div class="text-[14px] font-medium text-[#ff8f00] tracking-[0.1px]">
          Highway Items to Review
        </div>
        <div class="text-[12px] text-[rgba(0,0,0,0.6)] tracking-[0.4px]">
          Agents should review detailed information in Highway.
        </div>
        <Show when={intelSummary()}>
          <div class="text-[13px] font-medium text-[#1b4960]">
            {intelSummary()}
          </div>
        </Show>
      </Stack>
      <Show when={c()?.highwayUrl}>
        <Button
          variant="text"
          size="sm"
          class="shrink-0 text-[#026ea1]"
          endIcon={<OpenInNewIcon color="#026ea1" size={16} />}
          onClick={() =>
            window.open(`${c()?.highwayUrl}`, '_blank', 'noopener,noreferrer')
          }
          dataTestId="highway-profile-button"
        >
          Highway Profile
        </Button>
      </Show>
    </Stack>
  );
};
